import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Small, Large } from '../../../components/common/text';
import VascoFailIcon from '../../../components/common/icons/vasco-fail-icon';
import { DbLogoText } from '../../../common/components/icons';
import { PdfContent } from '../../modal-content';
//import Modal from '../../../components/common/blur-modal';
import { View } from '@dbk/ui-react-utils';
import Modal from '@dbk/ui-modal';
import { SHIELD_ERROR_CODES } from '../../../../../dbk-web/src/constants';

class VascoRasp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isModalActive: false,
      modalTitle: undefined,
    };
  }

  hideModal = () => {
    this.setState({
      isModalActive: false
    });
  };

  handleFaq = () => {
    this.props.changePage('/login-faq');
    // this.setState({
    //   isModalActive: !this.state.isModalActive,
    //   modalTitle:'FAQ'
    // });
  };

  modalContent = () => {
    return <PdfContent modalContentType="faq"/>
  };

  setModalTitle = (value) => {
    this.setState({
      modalTitle: value,
    });
  };

  render() {
    const {
      i18n: { messages },
    } = this.props;
    let splitPath = this.props.ui.history.currentLocation.pathname.split('/');
    let eventName = splitPath[splitPath.length-2];
    let eventMessage = '';
    if (eventName == 'jailbroken') {
      eventMessage = messages['app.vasco.rasp.jailbrokenError'];
    } else if (eventName == 'debugged') {
      eventMessage = messages['app.vasco.rasp.debuggedError'];
    } else if (eventName == 'repackaged') {
      eventMessage = messages['app.vasco.rasp.repackagedError'];
    } else if (eventName == 'libraryInjectionDetected') {
      eventMessage = messages['app.vasco.rasp.libraryInjectionError'];
    } else if (eventName == 'hookingFrameworkDetected') {
      eventMessage = messages['app.vasco.rasp.hookingFrameworkError'];
    } else if (eventName == 'nativeCodeHook') {
      eventMessage = messages['app.vasco.rasp.hookingFrameworkError'];
    } else if (eventName == 'foregroundOverride') {
      eventMessage = messages['app.vasco.rasp.foregroundOverrideError'];
    } else if (eventName == 'keyboardUntrusted') {
      eventMessage = messages['app.vasco.rasp.keyboardUntrustedError'];
    } else if (eventName == SHIELD_ERROR_CODES.ZERO) {
      eventMessage = messages['app.vasco.rasp.rootedDeviceError'];
    } else if (eventName == SHIELD_ERROR_CODES.ONE) {
      eventMessage = messages['app.vasco.rasp.repackagedDeviceError'];
    } else if (eventName == SHIELD_ERROR_CODES.TWO) {
      eventMessage = messages['app.vasco.rasp.emulatorError'];
    } else if (eventName == SHIELD_ERROR_CODES.THREE) {
      eventMessage = messages['app.vasco.rasp.javaDebuggerError'];
    } else if (eventName == SHIELD_ERROR_CODES.FOUR) {
      eventMessage = messages['app.vasco.rasp.untrustedKeyboardError'];
    } else if (eventName == SHIELD_ERROR_CODES.FIVE) {
      eventMessage = messages['app.vasco.rasp.untrustedScreenReaderError'];
    } else if (eventName == SHIELD_ERROR_CODES.SIX) {
      eventMessage = messages['app.vasco.rasp.nativeCodeHooksError'];
    } else if (eventName == (SHIELD_ERROR_CODES.SEVEN || SHIELD_ERROR_CODES.NINE || SHIELD_ERROR_CODES.TEN || SHIELD_ERROR_CODES.ELEVEN || SHIELD_ERROR_CODES.TWELVE || SHIELD_ERROR_CODES.THIRTEEN || SHIELD_ERROR_CODES.FOURTEEN)) {
      eventMessage = messages['app.vasco.rasp.internalError'];
    } else if (eventName == SHIELD_ERROR_CODES.EIGHT) {
      eventMessage = messages['app.vasco.rasp.configurationFileError'];
    } else if (eventName == SHIELD_ERROR_CODES.FIFTEEN) {
      eventMessage = messages['app.vasco.rasp.nativeLibraryError'];
    } else if (eventName == SHIELD_ERROR_CODES.SIXTEEN) {
      eventMessage = messages['app.vasco.rasp.hookingFrameworksError'];
    } else if (eventName == SHIELD_ERROR_CODES.SEVENTEEN) {
      eventMessage = messages['app.vasco.rasp.nativeDebuggerPreventionError'];
    } else if (eventName == SHIELD_ERROR_CODES.TWENTYSIX) {
      eventMessage = messages['app.vasco.rasp.developerOptionError'];
    } else if (eventName == SHIELD_ERROR_CODES.TWENTYSEVEN) {
      eventMessage = messages['app.vasco.rasp.untrustedInstallerError'];
    } else if (eventName == SHIELD_ERROR_CODES.TWENTYEIGHT) {
      eventMessage = messages['app.vasco.rasp.androidDeveloperBridgeError'];
    } else {
      eventMessage = messages['app.vasco.rasp.error1'];
    }

    return (
      <div className="scene">
        <DbLogoText className="Login__logo" />
        <div className="row vasco pad-top-40">
          <div className="columns small-12 text-center paddingClass">
            <div className="module pad-left-20 pad-right-20">
              <div>
                <VascoFailIcon color={'#fff'} />
                <div className="pad-bottom-30 pad-top-10">
                  <Text>{messages['app.vasco.rasp.error']}</Text>
                  <Text>{eventName}</Text>
                </div>
                <div className="pad-bottom-30 pad-top-10">
                  <Text>{messages['app.vasco.rasp.error1']}</Text>
                </div>
                <div className="pad-bottom-100">
                  <Text>{messages['app.vasco.rasp.error2']}</Text>
                </div>
              </div>
              {/* <div className="vascorasp_footer" onClick={this.handleFaq}>
                  {messages['app.login.rasp.faq']}
              </div> */}
            </div>
          </div>
        </div>
        {/* <Modal
          {...this.props}
          isActive={this.state.isModalActive}
          onClose={this.handleFaq}
          content={this.modalContent()}
        /> */}
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    ui: {
      history: {
        currentLocation: {
          pathname: true,
          route: true
        }
      }
    },
  },
})(VascoRasp);
